// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qgCOl","index":"styles_index__W_1aY"};